var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResetemotion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 10.5C1 11.091 1.1164 11.6761 1.34254 12.2221C1.56869 12.768 1.90016 13.2641 2.31802 13.682C3.16193 14.5259 4.30653 15 5.5 15H17.5C18.386 15.0016 19.2396 14.6671 19.8886 14.0641C20.5377 13.4611 20.9339 12.6343 20.9973 11.7506C21.0608 10.8669 20.7867 9.99207 20.2304 9.3025C19.6742 8.61293 18.8771 8.15998 18 8.03501C18.0098 6.33377 17.3996 4.68721 16.2837 3.4031C15.1677 2.119 13.6223 1.28525 11.9363 1.05772C10.2503 0.830184 8.5392 1.22444 7.12277 2.16678C5.70633 3.10912 4.68156 4.53505 4.24 6.17801C3.30512 6.45102 2.48398 7.01984 1.8998 7.79911C1.31562 8.57838 0.999892 9.52608 1 10.5Z",
    stroke: "black",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 7L13 11M9 11L13 7",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetemotion);
export default __webpack_public_path__ + "static/media/resetemotion.99f368ede16a40fe1a853da889656014.svg";
export { ForwardRef as ReactComponent };